// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__294dO","footer":"ReportModalFilter_footer__PkF6m"};